// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3aCjp","messages":"Chat_messages__2BGS5","dateDivider":"Chat_dateDivider__1n_42"};